<template>
  <GenericProgressLinear :icon="'mdi-trophy'" :title="'Achievements'" :stats="stats"></GenericProgressLinear>
</template>

<script>
import { mapGetters } from "vuex"
import GenericProgressLinear from "./GenericProgressLinear"

export default {
  name: "AchievementsProgressLinear",
  components: { GenericProgressLinear },
  computed: {
    ...mapGetters("entities/achievements", ["stats"])
  },
};
</script>
